/**
 * Config file for lazysizes.js
 */
window.lazySizesConfig = {
  'lazyClass': 'is-lazyLoad',
  'preloadClass': 'is-lazyPreload',
  'loadingClass': 'is-lazyLoading',
  'loadedClass': 'is-lazyLoaded',
  'autosizesClass': 'is-lazyAutosizes'
};
